// @flow
import { connect } from 'react-redux';
import type { State } from '../../../types';
import zoneActions from '../../../actions/zoneActions';
import { drawingSelector, listsSelector, drawingZoneSelector } from '../../../selectors/zoneSelectors';
import Zones from '../Zones';
import type { Props } from '../Zones';

const mapStateToProps = (state: State) => {
    return {
        lists: listsSelector(state),
        drawingEnabled: Boolean(drawingSelector(state)),
        drawingZone: drawingZoneSelector(state)
    };
};

const mapDispatchToProps = {
    enableDrawing: zoneActions.enableDrawingThunk,
    disableDrawing: zoneActions.disableDrawingThunk
};

export default connect<Props, _, _, _, _, _>(mapStateToProps, mapDispatchToProps)(Zones);